module.exports = __webpack_public_path__ + "static/media/IconTemplates_-66.163e4661.svg";